export default (state = {}, action) => {

    switch (action.type) {

        case 'UPDATE_BUSINESS_UNIT_REGION':
            return action.payload;

        default:

            return state;

    }

};